import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CastingHubService } from '../services';
import { CASTING_HUB_URL } from '../tokens';

export function provideCastingHub(hubPath: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    CastingHubService,
    { provide: CASTING_HUB_URL, useValue: hubPath },
  ]);
}
